var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('pulse-loader'):[(_vm.mso_login === true)?_c('common-mso',{attrs:{"children":_vm.children}}):_c('common-sso')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }